<template>
  <div>
    <!-- Sección de conexión -->
    <div class="margin-general connect_">
      <h3>{{ $t(title) }}</h3>
      <div class="card_connect">
        <!-- Render cards dynamically -->
        <div class="card" v-for="card in cards" :key="card.id">
          <span class="material-symbols-outlined" translate="no">{{ (card.imgSrc) }}</span>
          <p class="body-3">{{ $t(card.paragraphKey) }}</p>
          <p class="body-4" v-html="formatContent(card.subparagraphKey, $t)"></p>
          <a class="second-button-small" :href="card.linkUrl" v-if="card.id !== 2">{{ $t(card.linkKey) }}</a>
          <a class="second-button-small" @click="abrirChatHubSpot" v-if="card.id == 2">{{ $t(card.linkKey) }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n'; // Importa useI18n para acceder al idioma actual
import { formatContent } from '~/utils/formatContent';

const props = defineProps({
  title: String,
});

const { locale } = useI18n(); // Accede al idioma actual

defineEmits();

const abrirChatHubSpot = () => {
  if (window.HubSpotConversations) {
    window.HubSpotConversations.widget.open();
  } else {
    console.log('El widget de HubSpot Conversations no está disponible.');
  }
};

const cards = ref([
  {
    id: 1,
    imgSrc: "call",
    paragraphKey: "contacts.paragraph1",
    subparagraphKey: "contacts.subparagraph1",
    linkKey: "contacts.link1",
    linkUrl: "tel:+35620311017"
  },
  {
    id: 2,
    imgSrc: "chat",
    paragraphKey: "contacts.paragraph2",
    subparagraphKey: "contacts.subparagraph2",
    linkKey: "contacts.link2",
    linkUrl: ""
  },
  {
    id: 3,
    imgSrc: "mail",
    paragraphKey: "contacts.paragraph3",
    subparagraphKey: "contacts.subparagraph3",
    linkKey: "contacts.link3",
    linkUrl: "mailto:support@tradeview.eu"
  },
]);
</script>
